import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Импортируем useNavigate

import { toast, ToastContainer } from 'react-toastify'; // Импортируем ToastContainer и toast

import { getPaymentUrl, login } from '../services/Api'; // Импортируем функцию для авторизации

import 'react-toastify/dist/ReactToastify.css'; // Импортируем стили для toastify
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [paymentLink, setPaymentLink] = useState('');
  const navigate = useNavigate(); // Инициализируем useNavigate

  const fetchPaymentLink = async () => {
    try {
      const url = await getPaymentUrl();
      setPaymentLink(url);
    } catch {}
  };

  useEffect(() => {
    fetchPaymentLink();

    const intervalId = setInterval(() => {
      fetchPaymentLink();
    }, 150000);

    return () => clearInterval(intervalId);
  }, []);

  const handleSubmit = async event => {
    event.preventDefault();

    try {
      const response = await login(email, password);
      if (response.success) {
        // При успешной авторизации показываем уведомление и перенаправляем на страницу личного кабинета
        toast.success('Авторизация прошла успешно!');
        navigate('/profile');
      } else {
        // Если success === false, показываем сообщение об ошибке из API
        toast.error(response.message);
      }
    } catch (error) {
      // Обрабатываем ошибки, которые могут возникнуть при запросе (например, сетевые ошибки)
      toast.error(error.message || 'Произошла ошибка при авторизации');
    }
  };

  return (
    <section className="auth">
      <div className="auth__container">
        <h2 className="auth__title">Уже есть аккаунт?</h2>
        <p className="auth__subtitle">Авторизуйтесь!</p>
        <form id="login-form" className="auth__form" onSubmit={handleSubmit}>
          <div className="auth__form-group">
            <label className="auth__label" htmlFor="login">
              Логин:
            </label>
            <input
              className="auth__input"
              type="text"
              id="login"
              name="login"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              aria-label="Введите ваш логин"
            />
          </div>
          <div className="auth__form-group">
            <label className="auth__label" htmlFor="password">
              Пароль:
            </label>
            <input
              className="auth__input"
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              aria-label="Введите ваш пароль"
            />
          </div>
          <button className="auth__button" type="submit">
            Войти
          </button>
        </form>
        <p className="auth__footer">
          Нет аккаунта?
          <a
            href={paymentLink || '#'}
            id="payment-link"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              'font-weight': 600,
              'text-decoration': 'underline',
              'text-decoration-skip-ink': 'none',
              color: '#5c3cdb'
            }}
          >
            {paymentLink ? 'Оформить пробный период' : 'Загрузка...'}
          </a>
          {/* <button
            className="auth__link"
            onClick={() => alert('Оформите пробный период')}
            aria-label="Оформить пробный период"
          >
            Оформите пробный период
          </button> */}
        </p>
      </div>
      {/* Добавляем ToastContainer для отображения уведомлений */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </section>
  );
};

export default Login;
